import React from 'react';
import {Grid, Typography} from '@mui/material';
import {BuilderBankAccount} from '../../../../schema-types/BuilderBankAccount';
import {getAccountName, getBankName, getSortCode} from './bankAccountHelpers';

// note this should be used with BankAccountSummary
export const BankAccountDetails: React.FC<{
  bankAccount: BuilderBankAccount;
}> = ({bankAccount}) => {
  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={3}>
        <Typography>Bank Name:</Typography>
        <Typography>
          <strong>{getBankName(bankAccount) || 'N/A'}</strong>
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography>Account Name:</Typography>
        <Typography>
          <strong>{getAccountName(bankAccount) || 'N/A'}</strong>
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography>Account Number:</Typography>
        <Typography>
          <strong>{bankAccount.accountNumber || 'N/A'}</strong>
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography>Sort Code:</Typography>
        <Typography className="sentry-mask">
          <strong>{getSortCode(bankAccount.sortCode)}</strong>
        </Typography>
      </Grid>
    </Grid>
  );
};
